<template>
  <div id="app">
    <navigation/>
    <div>
		<div id="hero" class="flex flex-col justify-between items-center h-screen text-white">
			<div class="pt-64 text-center text-6xl text-shadow">
				<h1>Matthew Carson</h1>
				<h2 class="text-4xl mb-4">Web Developer</h2>
				<div class="flex justify-center">
					<img src="./assets/temple_uni_logo.png" alt="Temple University 'T' logo">
				</div>
			</div>
			<div>
				<svg @click="smoothScroll('#about')" 
					class="fill-current text-white h-16 hover:opacity-75 cursor-pointer" 
					xmlns="http://www.w3.org/2000/svg" 
					viewBox="0 0 20 20">
					<path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
				</svg>
			</div>
		</div>
		<block id="about" background="blue">
			<template slot="title">Who Am I?</template>
			<div class="flex flex-col lg:flex-row mx-auto items-center lg:item-start">
			  <div class="mr-0 lg:mr-8 lg:w-1/4 max flex flex-col justify-center">
			    <img class="mx-2 border-2 border-solid border-white mb-2 lg:img-responsive rounded" src="./assets/mc_photo.png" alt="Image of Matthew Carson">
			  </div>
			  <div class="text-2xl leading-normal w-3/4 text-white">
			    <p class="pb-6">My name is Matthew Carson. I am an aspiring web developer who loves the idea of being able to use technology to solve both simple and complex problems.</p>
			    <p class="pb-6">I was first introduced to web development while I attended Temple University from 2007 until 2012, where I graduated with a B.B.A. in Management Information Systems and Accounting. Recently, after feeling dissatisfied with my career trajectory, I rediscovered my passion for web development and recommitted myself to learning it in order to pursue a more fulfilling and gratifying career.</p>
			    <p class="pb-6">I have been learning web development for the past two years over which I have greatly increased my knowledge of PHP, specifically the Laravel MVC framework, as well as JavaScript, using the Vue.js front-end framework (which I used for this site). Currently I am working on gaining greater familiarity with content management systems such as Wordpress and Drupal.</p>
				<p class="pb-6">When I'm not trying to figure out regular expressions, I'm usually either reading fantasy novels and biographies or walking my pitbull, Duchess. In meiner Freizeit, lerne ich auch gern Deutsch.</p>
			    <p>I am currently located in the Philadelphia area.</p>
			  </div>
			</div>
		</block>
		<block id="skills">
			<template slot="title">My Skillset</template>
			<skill-icons></skill-icons>
		</block>
		<block background="blue" id="projects">
			<template slot="title">Sample Projects</template>
			<router-view></router-view>
		</block>
		<footer class="bg-white py-4" id="contact">
			<div class="m-auto my-0 w-1/2 text-center text-4xl">
				<a href="mailto:matthew.carson@pm.me" class="text-gray-900">
					<i class="far fa-envelope hover:opacity-75 mx-2"></i>
				</a>
				<a href="https://github.com/mcarson24"  class="text-gray-900 no-underline" target="_blank">
					<i class="devicon-github-plain hover:opacity-75 mx-2"></i>
				</a>
				<a href="./matthew_carson_resume_2025.pdf" class="text-gray-900">
					<i class="far fa-file-pdf hover:opacity-75 mx-2"></i>
				</a>
			</div>
		</footer>
	</div>
  </div>
</template>

<script>
	import Block from '@/components/Block.vue';
	import SkillIcons from '@/components/SkillIcons.vue';
	import Navigation from '@/components/Navigation.vue';

	export default {
		components: { Block, SkillIcons, Navigation },
		methods: {
			smoothScroll(element) {
				document.querySelector(element).scrollIntoView({ behavior: 'smooth'});
			}
		}
	}
</script>

<style src="./assets/css/tailwind.css"></style>
<style lang="scss">
	* {
		font-family: sans-serif;	
	}
	#hero {
		background: linear-gradient(rgba(26, 32, 44, .75), rgba(26, 32, 44, .75)), url('./assets/hero-photo.jpg') bottom center no-repeat;
		background-size: 100% 100vh; 
	}
	.max {
	   max-width: 400px;
	   max-height: 400px;
	}
</style>
